
export default {
  name: 'GridItemTags',
  props: {
    product: {
      type: Object,
      required: true,
    },
    collectionKitDiscountPercentage: {
      type: Number,
      required: false,
    },
    margin: {
      type: String,
      required: false,
      default: 'small',
      validator(value) {
        return ['small', 'large'].includes(value);
      },
    },
  },
  data() {
    return {
      tags: {
        discount: {
          text_color: theme.settings.discount_tag_text_color,
          bg_color: theme.settings.discount_tag_bg_color,
        },
        sale: {
          enabled: theme.settings.sale_tag_enabled,
          text: theme.settings.sale_tag_text,
          text_color: theme.settings.sale_tag_text_color,
          bg_color: theme.settings.sale_tag_bg_color,
          position: theme.settings.sale_tag_position,
        },
        bonus: {
          enabled: theme.settings.bonus_tag_enabled,
          text: theme.settings.bonus_tag_text,
          text_color: theme.settings.bonus_tag_text_color,
          bg_color: theme.settings.bonus_tag_bg_color,
          position: theme.settings.bonus_tag_position,
        },
        new: {
          enabled: theme.settings.new_tag_enabled,
          text: theme.settings.new_tag_text,
          text_color: theme.settings.new_tag_text_color,
          bg_color: theme.settings.new_tag_bg_color,
          position: theme.settings.new_tag_position,
        },
        sold_out: {
          text: theme.translations.sold_out,
        },
      },
    };
  },
  computed: {
    discountTag() {
      const discountAmount =
        ((this.product.compare_at_price - this.product.price) * 100) /
        this.product.compare_at_price;

      return Math.round(discountAmount);
    },
    fixedDiscountTag() {
      const fixedDiscountAmount = this.product.tags.find((tag) => tag.includes('fixed-discount'));

      return `-${fixedDiscountAmount?.split(':')[1]}%`;
    },
    hasLeftPositionProperty() {
      const tagKeys = Object.keys(this.tags);

      for (let i = 0; i < tagKeys.length; i += 1) {
        const tagName = tagKeys[i];
        const tag = this.tags[tagName];
        if (tag.position && tag.position.includes('left')) {
          return true;
        }
      }
      return false;
    },
    hasRightPositionProperty() {
      const tagKeys = Object.keys(this.tags);

      for (let i = 0; i < tagKeys.length; i += 1) {
        const tagName = tagKeys[i];
        const tag = this.tags[tagName];
        if (tag.position && tag.position.includes('right')) {
          return true;
        }
      }
      return false;
    },
    marginLeft() {
      if (this.margin === 'small') return 'mt-8 ml-8';
      return 'mt-16 ml-16';
    },
    marginRight() {
      if (this.margin === 'small') return 'mt-8 mr-8';
      return 'mt-16 mr-16';
    },
  },
};
